import { render, staticRenderFns } from "./RChartColumn.vue?vue&type=template&id=2b98f4c7&"
import script from "./RChartColumn.vue?vue&type=script&lang=js&"
export * from "./RChartColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports